// Pricer colours, labels, borders and storage keys. Data only (A2-1600).

import { FIELD_NAMES } from "./fields";

export const COLUMN_CELL_TO_HAVE_RIGHT_BORDER = [
  FIELD_NAMES.TENOR_LEG,
  FIELD_NAMES.LIVE,
  FIELD_NAMES.RATIO,
  FIELD_NAMES.ASK_QTY,
  FIELD_NAMES.ACTIONS,
  FIELD_NAMES.TENOR,
];

export const PRICER_NODES_COLORS = "pricer_nodeColors";
export const RowColor = "rowColor";
export const GreenColor = "--color-green-2";
export const YellowColor = "--color-yellow-2";
export const MagentaColor = "--color-magenta-1";

export const PRICER_KEYS_NOT_INCLUDED = [
  "product_id",
  "premium_unit",
  "underlying_unit",
  "strike_unit",
  "risk_free_unit",
  "premium_percentage_unit",
  "premium_theta_unit",
  "premium_delta_unit",
  "premium_gamma_unit",
  "premium_quantity_unit",
  "premium_vega_currency_unit",
  "premium_rho_currency_unit",
  "premium_total_premium_unit",
  "premium_breakeven_unit",
  "premium_vega_unit",
  "premium_rho_unit",
  "premium_theta_currency_unit",
  "premium_gamma_quantity_unit",
  "premium_delta_quantity_unit",
  "premium_total_quantity_unit",
  "copy_shorthand_legs",
  "summary_agg",
  "expiry_date",
  "children_count",
  "is_auto_update_vol",
];

export const TENOR_EXPIRY = "Tenor Expiry";
export const OTHER_INFORMATION = "Other Information";
export const EDIT_OTHER_DETAILS = "Edit Other Details";
export const OPTION = "Option";

export const EDIT_OTHER_DETAILS_LABELS = {
  CURRENT_AVERAGE: {
    label: "Current Average",
    isDisabled: true,
    key: "average",
  },
  NEW_AVERAGE: { label: "New Average", isDisabled: false, key: "new_average" },
  CURRENT_COST_OF_CARRY: {
    label: "Current Cost Of Carry",
    isDisabled: true,
    key: "cost_of_carry",
  },
  NEW_COST_OF_CARRY: {
    label: "New Cost Of Carry",
    isDisabled: false,
    key: "new_cost_of_carry",
  },
};

/** localStorage key — per-slot chosen bid-side greek field keys (strings "0".."5") */
export const PRICER_TRADER_GREEKS_STORAGE_KEY = "pricerTraderGreeks";
